/**
 * Canonical User.status strings (aligned with API).
 * Legacy numeric 1–4 from older responses are normalized on read.
 */

export const USER_ACCOUNT_STATUS = {
  ACTIVE: "active",
  PENDING: "pending",
  INACTIVE: "inactive",
  BANNED: "banned",
};

const LEGACY = {
  1: USER_ACCOUNT_STATUS.ACTIVE,
  2: USER_ACCOUNT_STATUS.PENDING,
  3: USER_ACCOUNT_STATUS.INACTIVE,
  4: USER_ACCOUNT_STATUS.BANNED,
};

const ALL = new Set(Object.values(USER_ACCOUNT_STATUS));

export function normalizeUserAccountStatus(raw) {
  if (raw == null || raw === "") return USER_ACCOUNT_STATUS.ACTIVE;
  if (typeof raw === "number" && LEGACY[raw] != null) return LEGACY[raw];
  const str = String(raw).trim();
  if (/^\d+$/.test(str)) {
    const n = Number(str);
    if (LEGACY[n] != null) return LEGACY[n];
  }
  const lower = str.toLowerCase();
  if (ALL.has(lower)) return lower;
  return USER_ACCOUNT_STATUS.ACTIVE;
}

export function userDirectoryLoginAllowed(user) {
  if (!user) return false;
  if (user.active === false) return false;
  return normalizeUserAccountStatus(user.status) === USER_ACCOUNT_STATUS.ACTIVE;
}

export function userAccountStatusLabel(status) {
  const s = normalizeUserAccountStatus(status);
  if (s === USER_ACCOUNT_STATUS.ACTIVE) return "Active";
  if (s === USER_ACCOUNT_STATUS.PENDING) return "Pending";
  if (s === USER_ACCOUNT_STATUS.INACTIVE) return "Inactive";
  if (s === USER_ACCOUNT_STATUS.BANNED) return "Banned";
  return "Active";
}

/** Bootstrap color suffix for badges: success | warning | secondary | danger */
export function userAccountStatusBadgeVariant(status) {
  const s = normalizeUserAccountStatus(status);
  if (s === USER_ACCOUNT_STATUS.ACTIVE) return "success";
  if (s === USER_ACCOUNT_STATUS.PENDING) return "warning";
  if (s === USER_ACCOUNT_STATUS.INACTIVE) return "secondary";
  return "danger";
}

export function userAccountStatusShortHint(status) {
  const s = normalizeUserAccountStatus(status);
  if (s === USER_ACCOUNT_STATUS.PENDING) return "pending verification";
  if (s === USER_ACCOUNT_STATUS.INACTIVE) return "inactive (paused)";
  if (s === USER_ACCOUNT_STATUS.BANNED) return "banned";
  return "inactive";
}
